import permissions from '../application/detail/permissions.json';
export class PermissionsService {
    static $inject = ['$state', '$rootScope'];
    constructor($state, $rootScope) {
        'ngInject';
        this.$state = $state;
        this.$rootScope = $rootScope;
    }
    async hasPermissions(permissionType, customArea, customShortName) {
        const application = this.$rootScope.application;
        const area = customArea || this.$state.params.area;
        if (application.isSubflow) {
            //TODO: Implement permissions rules of subflow later
            return true;
        }
        /**
         * TODO: Remove this conditional and set dashboard permissions on API
         */
        if (area == 'dashboard') {
            return true;
        }
        if (!permissions[area]) {
            return false;
        }
        const areaClaim = permissions[area].claim;
        const userPermission = application.applicationUserPermissionModel.find((p) => p.permissionClaim == areaClaim);
        let permission;
        switch (permissionType) {
            case 'write':
                permission = 3;
                break;
            case 'read':
                permission = 1;
                break;
        }
        if (!userPermission || userPermission.permissionAction < permission) {
            return false;
        }
        return true;
    }
    async getPermissionsObject() {
        return new Promise(resolve => resolve(permissions));
    }
    getDeskPermissions() {
        if (!permissions['desk']) {
            return [];
        }
        const deskPermissions = this.getAllRelatedPermissions('desk');
        const deskPermissionsWithLevels = this.buildPermissionsWithLevels(deskPermissions);
        return deskPermissionsWithLevels;
    }
    getAllRelatedPermissions(relatedKey) {
        const relatedPermissions = {};
        Object.keys(permissions).forEach(key => {
            const permission = permissions[key];
            if (key === relatedKey || permission.parent === relatedKey) {
                relatedPermissions[key] = permission;
            }
        });
        return relatedPermissions;
    }
    buildPermissionsWithLevels(permissionsObj) {
        const application = this.$rootScope.application;
        const permissionsWithLevels = {};
        Object.keys(permissionsObj).forEach(key => {
            const permission = permissionsObj[key];
            const userPermission = application.applicationUserPermissionModel.find((p) => p.permissionClaim === permission.claim);
            let permissionAction = 0;
            if (userPermission) {
                permissionAction = userPermission.permissionAction;
            }
            else if (permission.parent !== undefined && permissionsObj[permission.parent] !== undefined) {
                const parentUserPermission = application.applicationUserPermissionModel.find((p) => p.permissionClaim === permissionsObj[permission.parent].claim);
                permissionAction = parentUserPermission ? parentUserPermission.permissionAction : 0;
            }
            switch (permissionAction) {
                case 0:
                    permissionsWithLevels[key] = 'None';
                    break;
                case 1:
                    permissionsWithLevels[key] = 'Read';
                    break;
                case 3:
                    permissionsWithLevels[key] = 'Write';
                    break;
                default:
                    permissionsWithLevels[key] = 'None';
            }
        });
        return permissionsWithLevels;
    }
}
